import { render, staticRenderFns } from "./iristarAiSoftware.vue?vue&type=template&id=4dc55b88&scoped=true&"
import script from "./iristarAiSoftware.vue?vue&type=script&lang=js&"
export * from "./iristarAiSoftware.vue?vue&type=script&lang=js&"
import style0 from "./iristarAiSoftware.vue?vue&type=style&index=0&id=4dc55b88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc55b88",
  null
  
)

export default component.exports